export default "__VITE_ASSET__mSuP7Jx9__"